import { defineComponent } from "vue";
import NavHeaderVue from "@/components/nav-header/NavHeader.vue";
import NavAsideVue from "@/components/nav-aside/NavAside.vue";
import Player from "@/components/player/player.vue";
import PlayerDetail from "@/components/player/playerDetail.vue";
export default defineComponent({
  name: "Main",
  setup: function setup() {
    return {};
  },
  components: {
    NavHeaderVue: NavHeaderVue,
    NavAsideVue: NavAsideVue,
    Player: Player,
    PlayerDetail: PlayerDetail
  }
});